// ============================================
// Path: /frontend/src/components/HeroSection.jsx
// Purpose: Homepage hero banner with call-to-action buttons
// ============================================

export function HeroSection() {
  console.log('[HeroSection] Rendering hero section');

  return (
    <section className="relative h-[20vh] min-h-[180px] w-full flex items-center justify-center text-white">
      <img
        src="/images/hero-bg.jpg"
        alt="Hero background"
        data-ai-hint="modern city skyline"
        className="absolute inset-0 w-full h-full object-cover"
        onError={(e) => {
          console.error('[HeroSection] Hero image failed to load');
          e.target.src = 'https://placehold.co/1920x540/333/fff?text=MotoHome+Finder';
        }}
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 text-center px-6 py-4 w-full">
        <p className="mb-4 max-w-2xl mx-auto text-base sm:text-lg md:text-xl drop-shadow">
          Discover thousands of listings for cars and properties, all in one place.
        </p>
      </div>
    </section>
  );
}